/* eslint-disable */
import clsx from "clsx";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MHWhiteLogo } from "../../../assets/Icons";
import Button from "../Button";
import Cookies from "universal-cookie";
import { isMasterVendor } from "../../../store";
import { signOut } from "../../../services/auth";
import { useRecoilState } from "recoil";
import { jwtDecode } from "jwt-decode";
import { clearAuth, setGlobalUserData } from "../../../pages/remittance-beta/state/authSlice";
import { configActions } from "../../../state/config/configSlice";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { remittanceActions } from "../../../pages/remittance-beta/state/remittanceSlice";
import MixpanelConfig from "../../../constants/MixpanelConfig";

interface ConveraPaymentProps {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  country?: string;
  institution: string;
}

const cookies = new Cookies();

const commonButtonList = [
  { btnText: "Fx Rates", pathName: "/fxrates", track: "Fx_rates" },
  { btnText: "Initiate Transaction", pathName: "/remittance", track: "Initiate_transaction" },
  { btnText: "History", pathName: "/history", track: "History" },
];
export const Header = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);
  const [masterVendor, setMasterVendor] = useRecoilState(isMasterVendor);
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const everestPartner = localStorage.getItem("everestPartner");
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [userEmail, setUserEmail] = useState<string>("");
  const [userRole, setUserRole] = useState<string>("");
  const lastStoredUserRef = useRef<string | null>(null);
  const lastUserTokenRef = useRef<string | null>(null);
  const profileMenuRef = useRef<HTMLDivElement | null>(null);
  // const [headerList, setHeaderList] = useState<{ btnText: string; pathName: string; track: string; }[]>([]);

  const authState = useAppSelector((state) => state.auth);

  const headerList = useMemo(() => {
    let defaultButtonList = [...commonButtonList];

    if (
      (masterVendor && everestPartner === null) ||
      (masterVendor && !everestPartner) ||
      (masterVendor && everestPartner === "false")
    ) {
      defaultButtonList.push(
        { btnText: "Margin", pathName: "/margin", track: "Margin" },
        {
          btnText: "Commissions",
          pathName: "https://books.zohosecure.in/portal/moneyhop",
          track: "Commissions",
        },
        { btnText: "Sub Vendor", pathName: "/subvendor-margin", track: "Sub_vendor_margin" }
      );
    } else if (masterVendor && everestPartner) {
      defaultButtonList.push({
        btnText: "Sub Vendor",
        pathName: "/subvendor-margin",
        track: "Sub_vendor_margin",
      });
    } else if (masterVendor === false && everestPartner === "false") {
      defaultButtonList.push({ btnText: "Margin", pathName: "/margin", track: "Margin" });
    }

    return defaultButtonList;
  }, [masterVendor, everestPartner]);

  const listItemClassname =
    "px-8 py-2 font-semibold text-black transition-all bg-white bg-gray-100 hover:bg-gray-200 z-50 transition-all";

  const handleLogout = () => {
    setIsProfileMenuOpen(false);
    cookies.remove("XSRF-TOKEN");
    localStorage.clear();
    dispatch(clearAuth());
    dispatch(configActions.clearFeatureSet());
    sessionStorage.clear();
    signOut(currentUser)
      .then((response: any) => {
        if (response?.data) {
          setMasterVendor(false);
        }
      })
      .catch((error) => {
        {
          console.warn("Failed to logout..!", error);
        }
      })
      .finally(() => {
        navigate("/auth/sign-in-new");
      });
  };

  const syncUserDetailsFromStorage = useCallback(() => {
    let storedUser: Record<string, any> = {};
    const storedUserString = localStorage.getItem("currentUser");
    const hasStoredUserChanged = storedUserString !== lastStoredUserRef.current;

    if (storedUserString) {
      try {
        storedUser = JSON.parse(storedUserString);
      } catch (error) {
        console.warn("Unable to parse stored user", error);
      }
    }

    const deriveEmail = () => {
      const storedEmailKey = localStorage.getItem("userEmail")?.trim() || "";

      const emailFromCurrentUser =
        storedUser?.username || storedUser?.email || storedUser?.userDetails?.email || "";

      if (hasStoredUserChanged) {
        lastStoredUserRef.current = storedUserString;
        if (emailFromCurrentUser) {
          if (emailFromCurrentUser !== storedEmailKey) {
            localStorage.setItem("userEmail", emailFromCurrentUser);
            dispatch(setGlobalUserData({ userEmail: emailFromCurrentUser }));
          }
          return emailFromCurrentUser;
        }
      }

      if (!storedEmailKey && emailFromCurrentUser) {
        localStorage.setItem("userEmail", emailFromCurrentUser);
        dispatch(setGlobalUserData({ userEmail: emailFromCurrentUser }));
        return emailFromCurrentUser;
      }

      return storedEmailKey || emailFromCurrentUser;
    };

    const deriveRole = () => {
      const storedRoleKey = localStorage.getItem("userRole")?.trim() || "";

      const token = sessionStorage.getItem("userToken") || localStorage.getItem("userToken");
      const hasTokenChanged = token !== lastUserTokenRef.current;

      let roleFromToken = "";

      if (token && (hasTokenChanged || !storedRoleKey)) {
        try {
          const payload = jwtDecode<{ Role?: string; role?: string }>(token);
          roleFromToken = payload?.Role || payload?.role || "";
        } catch (error) {
          console.warn("Unable to decode user role from token", error);
        }
      }

      if (hasTokenChanged) {
        lastUserTokenRef.current = token;
      }

      if (roleFromToken) {
        if (hasTokenChanged || !storedRoleKey) {
          localStorage.setItem("userRole", roleFromToken);
          dispatch(setGlobalUserData({ userRole: roleFromToken }));
        }
        return roleFromToken;
      }

      return storedRoleKey || roleFromToken;
    };

    const nextEmail = deriveEmail() || "";
    const nextRole = deriveRole() || "";

    setUserEmail((prev) => (prev !== nextEmail ? nextEmail : prev));
    setUserRole((prev) => (prev !== nextRole ? nextRole : prev));
  }, []);

  useEffect(() => {
    syncUserDetailsFromStorage();

    const handleStorageChange = (event: StorageEvent) => {
      if (
        event.key === null ||
        ["userEmail", "userRole", "currentUser", "userToken"].includes(event.key)
      ) {
        syncUserDetailsFromStorage();
      }
    };

    const intervalId = window.setInterval(syncUserDetailsFromStorage, 500);

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.clearInterval(intervalId);
    };
  }, [syncUserDetailsFromStorage]);

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (profileMenuRef.current && !profileMenuRef.current.contains(event.target as Node)) {
        setIsProfileMenuOpen(false);
      }
    };

    if (isProfileMenuOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isProfileMenuOpen]);

  const profileInitial = (userEmail || "").trim().charAt(0).toUpperCase();
  const profileDisplayName = userEmail;

  const formattedRole = useMemo(() => {
    if (!userRole) {
      return "";
    }

    const lowerCased = userRole.toLowerCase();
    return lowerCased.charAt(0).toUpperCase() + lowerCased.slice(1);
  }, [userRole]);

  return (
    <>
      <div className="h-[65px] fixed top-0 left-0 z-50 w-full bg-[#0F5BF1] flex justify-between items-center shadow-sm">
        <div
          onClick={() => navigate("/home")}
          id="logo"
          className="flex justify-start ml-4 lg:ml-8 cursor-pointer scale-90 origin-left"
        >
          <MHWhiteLogo />
        </div>
        <div id="buttons">
          <div className="flex items-center space-x-5 mr-4 lg:mr-8">
            {headerList.map((item, index) => (
              <Button
                key={index}
                className="text-[16px] bg-[#0F5BF1] text-white font-semibold group peer relative h-[65px]"
                onClickHandler={() => {
                  if (item.pathName === "/remittance") {
                    setIsDropdownOpen(!isDropdownOpen);
                  } else if (item.btnText === "Commissions") {
                    window.open(item.pathName, "_blank");
                  } else {
                    navigate(item.pathName);
                  }
                }}
              >
                {item.btnText}
                {/* mt-[190px] */}
                <div
                  className={clsx(
                    item.btnText === "Initiate Transaction"
                      ? currentUser?.username?.includes("moneyhop.co")
                        ? "absolute top-[46px] left-0 flex-col hidden w-[250px] group-hover:flex peer-hover:flex hover:flex shadow-xl shadow-gray-500 z-10 rounded"
                        : "absolute top-[46px] left-0 flex-col hidden w-[250px] group-hover:flex peer-hover:flex hover:flex shadow-xl shadow-gray-500 z-10 rounded"
                      : "hidden"
                  )}
                >
                  <span
                    onClick={() => {
                      dispatch(remittanceActions.resetRemittanceState());
                      navigate("/send/calculator");
                      MixpanelConfig.trackEvent(MixpanelConfig.eventNames.MoneyHOPOnline_Beta, {});
                      // if(authState?.currentUser?.username?.includes("moneyhop.co")) {
                      //   dispatch(remittanceActions.resetRemittanceState());
                      //   navigate("/send/calculator");
                      //   MixpanelConfig.trackEvent(MixpanelConfig.eventNames.MoneyHOPOnline_Beta, {});
                      // } else {
                      //   navigate("/remittance");
                      //   MixpanelConfig.trackEvent(MixpanelConfig.eventNames.MoneyHOPOnline, {});
                      // }
                    }}
                    className={listItemClassname}
                  >
                    moneyHOP Online
                  </span>
                  {/* {authState?.currentUser?.username?.includes("moneyhop.co") && (
                <span
                  onClick={() => {
                    dispatch(remittanceActions.resetRemittanceState());
                    navigate("/send/calculator");
                    MixpanelConfig.trackEvent(MixpanelConfig.eventNames.MoneyHOPOnline_Beta, {});
                  }}
                  className={listItemClassname}
                >
                  moneyHOP Online 
                  <span className="ml-2 p-1 text-xs bg-green-500 text-white rounded">
                    Beta
                  </span>
                </span>
                )} */}
                  <span
                    onClick={() => {
                      navigate("/convera");
                    }}
                    className={listItemClassname}
                  >
                    moneyHOP x Convera
                  </span>
                  <span
                    onClick={() => {
                      navigate("/flywire");
                    }}
                    className={listItemClassname}
                  >
                    Flywire
                  </span>
                  {currentUser?.username?.includes("moneyhop.co") ? (
                    <>
                      <span
                        onClick={() => {
                          navigate("/offline");
                        }}
                        className={listItemClassname}
                      >
                        Offline
                      </span>
                      <span
                        onClick={() => {
                          navigate("/travel-card");
                        }}
                        className={listItemClassname}
                      >
                        Travel Card
                      </span>
                    </>
                  ) : null}
                </div>
              </Button>
            ))}
            <div
              onClick={() => setIsProfileMenuOpen((prev) => !prev)}
              className="flex items-center space-x-2 text-white cursor-pointer"
            >
              {userEmail ? (
                <span className="text-[16px] font-medium" title={userEmail}>
                  {userEmail}
                </span>
              ) : null}
              <div className="relative" ref={profileMenuRef}>
                <button
                  type="button"
                  // onClick={() => setIsProfileMenuOpen((prev) => !prev)}
                  className="flex h-8 w-8 items-center justify-center rounded-full bg-gradient-to-br from-[#5B8CFF] to-[#3A63F5] text-sm font-semibold uppercase text-white transition hover:opacity-90"
                >
                  {profileInitial || ""}
                </button>
                {isProfileMenuOpen ? (
                  <div className="absolute right-0 mt-3 w-72 rounded-lg bg-white py-3 shadow-xl">
                    <div className="flex items-center gap-3 px-4 pb-3">
                      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gradient-to-br from-[#5B8CFF] to-[#3A63F5] text-lg font-semibold uppercase text-white">
                        {profileInitial || ""}
                      </div>
                      <div className="min-w-0">
                        <p
                          className="break-words text-sm font-semibold text-gray-900"
                          title={profileDisplayName}
                        >
                          {profileDisplayName || "User"}
                        </p>
                        {formattedRole ? (
                          <p className="mt-0.5 text-xs font-medium tracking-wide text-gray-500">
                            {formattedRole}
                          </p>
                        ) : null}
                      </div>
                    </div>
                    <div className="mx-4 my-2 h-px bg-gray-200" />
                    <button
                      type="button"
                      onClick={() => handleLogout()}
                      className="mt-1 flex w-full items-center gap-2 px-4 py-2 text-sm font-semibold text-red-600 transition hover:bg-red-50"
                    >
                      <span>Log out</span>
                    </button>
                  </div>
                ) : null}
              </div>
            </div>
            {/* <div className="flex items-center justify-center">
            <Button
              onClickHandler={() => handleLogout()}
              className="font-semibold text-[16px] h-[40px] rounded-full text-white bg-[#FF820E]"
            >
              Logout
            </Button>
          </div> */}
          </div>
        </div>
      </div>
      <div className="h-[65px] w-full" />
    </>
  );
};
